<template>
  <v-container fluid fill-height>
    <v-layout row>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-tabs v-model="activeTab" grow slider-color="primary">
              <v-tab href="#data" active-class="tabs__item--active dps-tab-selected">
                {{ $t('private_parking_invoices_billing_title') }}
              </v-tab>

              <v-tab href="#list" active-class="tabs__item--active dps-tab-selected">
                {{ $t('private_parking_invoices_table_title') }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
              <v-tab-item value="data">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-data-table disable-initial-sort hide-actions no-data-text="" hide-headers :items="tableData" :rows-per-page-items="rowsPerPageItems" class="spacing-top">
                      <template slot="items" slot-scope="props">
                        <td width="50%">{{ props.item.label }}</td>
                        <td>
                          {{ props.item.value }}
                        </td>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-tab-item>
              <v-tab-item value="list">
                <v-flex xs12>
                  <invoices-table-box :parking-id="parkingId" class="spacing-top"></invoices-table-box>
                </v-flex>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import parkingService from '@/services/parkingService';
import store from '@/store';
import InvoicesTableBox from '@/components/commons/InvoicesTableBox.vue';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'ParkingInvoices',
  components: {
    [InvoicesTableBox.name]: InvoicesTableBox
  },
  data() {
    return {
      rowsPerPageItems: [25, 50, 100, { text: this.$i18n.t('row_pagination_all'), value: -1 }],
      dates: [],
      tableData: [],
      parking: {},
      activeTab: 'data',
      parkingId: this.$route.params.id
    };
  },
  created() {
    if (store.state.parkingSelected !== null && this.parkingId === store.state.parkingSelected) {
      this.parking = store.state.parkingSelected;
    }
    this.loadData();
    EventBus.$on(keys.eventOnLanguageChanged, this.onLanguageChanged);
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.onLanguageChanged);
  },
  methods: {
    onLanguageChanged() {
      this.rowsPerPageItems = [25, 50, 100, { text: this.$i18n.t('row_pagination_all'), value: -1 }];
    },
    loadData() {
      let params = {
        parking: this.parkingId
      };
      parkingService.summary(params, this.summarySuccessHandler, this.summaryErrorHandler);
    },
    summarySuccessHandler(data) {
      this.parking = data;
      this.tableData = [
        { label: this.$i18n.t('private_parking_invoices_billing_name'), value: data.billing.name },
        { label: this.$i18n.t('private_parking_invoices_billing_email'), value: data.billing.email },
        { label: this.$i18n.t('private_parking_invoices_billing_cif'), value: data.billing.cif },
        { label: this.$i18n.t('private_parking_invoices_billing_address'), value: data.billing.address },
        { label: this.$i18n.t('private_parking_invoices_billing_phone'), value: data.billing.phone },
        { label: this.$i18n.t('private_parking_invoices_billing_bank'), value: data.billing.accountNumber }
      ];
      store.commit('UPDATE_PARKING_SELECTED', this.parking);
    },
    summaryErrorHandler(error) {
      if (error.status === 404) {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: 'error_404',
          type: 'error'
        });
      }

      this.$router.push({ name: 'Dashboard' });
    }
  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/parking/Invoices.vue